<main class="dashboard">
	<app-dialog-layout>
		<mat-accordion style="width: 100%;">
			<mat-expansion-panel expanded="true">
				<mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight">
					<mat-panel-title>
						{{ "MAIN_APP_DASHBOARD.zuletztVerwendeteObjekte" | translate }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<div *ngIf="hasLastViewedObjects == 1">
					<mat-spinner *ngIf="isLoadingObjectsResults" style="margin: 0 auto"></mat-spinner>
					<table [dataSource]="dataSourceObjekte" mat-table>
						<!-- Objekt-Nr. Column -->
						<ng-container matColumnDef="objectNo">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.objekt-Nr" | translate }}.
							</th>
							<td *matCellDef="let element" mat-cell>
								{{ element.objectNumber }}
							</td>
						</ng-container>
						
						<!-- Objekttyp Column -->
						<ng-container matColumnDef="typeDesc">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.typ" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>
								{{ element.typeDescription }}
							</td>
						</ng-container>
						
						<!-- Bezeichnung Column -->
						<ng-container matColumnDef="desc">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.bezeichnung" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>
								{{ element.description }}
							</td>
						</ng-container>
						
						<!-- Note4 Column -->
						<ng-container matColumnDef="objekt">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.objekt" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.note4 }}</td>
						</ng-container>
						
						<!-- Strasse Column -->
						<ng-container matColumnDef="address">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.strasse" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.address }}</td>
						</ng-container>
						
						<!-- Plz Column -->
						<ng-container matColumnDef="zip">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.plz" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.zipCode }}</td>
						</ng-container>
						
						<!-- Ort Column -->
						<ng-container matColumnDef="town">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.ort" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.town }}</td>
						</ng-container>
						
						<tr *matHeaderRowDef="displayedObjektColumns" mat-header-row></tr>
						<tr (click)="highlight(row)" *matRowDef="let row; columns: displayedObjektColumns" [ngClass]="{ highlight: selectedObjectID == row.objectID }" mat-row></tr>
					</table>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
		<mat-accordion style="width: 100%;">
			<mat-expansion-panel expanded="true">
				<mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight">
					<mat-panel-title>
						{{
							"MAIN_APP_DASHBOARD.zuletztVerwendeteAdressen" | translate
						}}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<div *ngIf="hasLastViewedAddresses == 1">
					<mat-spinner *ngIf="isLoadingAddressesResults" style="margin: 0 auto"></mat-spinner>
					<table [dataSource]="dataSourceAdressen" mat-table>
						<ng-container matColumnDef="adressNo">
							<th *matHeaderCellDef mat-header-cell>Adr.-Nr.</th>
							<td *matCellDef="let element" mat-cell>{{ element.adressNo }}</td>
						</ng-container>
						<ng-container matColumnDef="name">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.name" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.lastName }}</td>
						</ng-container>
						<ng-container matColumnDef="vorname">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.vorname" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.firstName }}</td>
						</ng-container>
						<ng-container matColumnDef="strasse">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.strasse" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.street1 }}</td>
						</ng-container>
						<ng-container matColumnDef="plzOrt">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.plz" | translate }}/{{
									"MAIN_APP_DASHBOARD.ort" | translate
								}}
							</th>
							<td *matCellDef="let element" mat-cell>
								{{ element.zip }} {{ element.city }}
							</td>
						</ng-container>
						<ng-container matColumnDef="tel">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.telefon" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.phone01 }}</td>
						</ng-container>
						<ng-container matColumnDef="mobile">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.mobile" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.phone03 }}</td>
						</ng-container>
						<ng-container matColumnDef="eMail">
							<th *matHeaderCellDef mat-header-cell>
								{{ "MAIN_APP_DASHBOARD.email" | translate }}
							</th>
							<td *matCellDef="let element" mat-cell>{{ element.email }}</td>
						</ng-container>
						
						<tr *matHeaderRowDef="displayedAdresseColumns" mat-header-row></tr>
						<tr (click)="highlightAdr(row)" *matRowDef="let row; columns: displayedAdresseColumns" [ngClass]="{ highlight: selectedAdressID == row.adressID }" mat-row></tr>
					</table>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</app-dialog-layout>
</main>
